import React, { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router';
import './DashboardLayout.css';
import profileIcon from '../../images/admin.jpeg'


const DashboardLayout = () => {
    const [active, setActive] = useState("home");


    const navigate = useNavigate()



    return (
        <div className='fullbody'>

            <section className='layout-header'>
                <div className='layout-header-inner'>
                    <div>
                        <p className='hedeer-title'>deshi agro foods Admin Panel</p>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div><p style={{ color: 'white', fontWeight: '700' }}>Welcome Mr. Hasibul Hasan</p></div>
                        <div style={{ height: '50px', width: '50px', borderRadius: '25px', border: '1px solid ', marginLeft: '5px' }} >
                            <img src={profileIcon} alt="" style={{ height: '100%', width: '100%', borderRadius: '10px' }} />
                        </div>

                    </div>
                </div>

            </section >

            <section style={{ display: 'grid', gridTemplateColumns: '13% 87%', width: '100%' }}>
                <div style={{ backgroundColor: '#11032ae5', width: '100%', margin: '0 auto', paddingLeft: '3%' }}>


                    <div style={{ width: '100%', margin: '1px auto', minHeight: '80vh' }}>
                        <div style={{ textAlign: 'center' }}>
                            <button className='previewBtn'> <a href="https://deshiagrofoods.com/" target='_blank'>visti website</a></button><hr />
                        </div>




                        <section>
                            <Link onClick={() => navigate("..")} to='' className='nav-container-link'>
                                <div onClick={() => setActive("home")} style={{ backgroundColor: active === "home" ? "white" : "", cursor: "pointer", }} className='nav-container'>
                                    <p onClick={() => setActive("home")} style={{ color: active === "home" ? "black" : "white", cursor: "pointer" }} className='nav-container-link' to=''>dashboard</p></div> </Link>
                        </section>
                        <section>
                            <Link to='landingpages' className='nav-container-link'>
                                <div onClick={() => setActive("landingpages")} style={{ backgroundColor: active === "landingpages" ? "white" : "", cursor: "pointer" }} className='nav-container'>
                                    <p onClick={() => setActive("landingpages")} style={{ color: active === "landingpages" ? "" : "white", cursor: "pointer" }} className='nav-container-link' to='landingpages'>Landing Pages</p></div> </Link>
                        </section>
                        <section>
                            <Link to='orders' className='nav-container-link'>
                                <div onClick={() => setActive("order")} style={{ backgroundColor: active === "order" ? "white" : "", cursor: "pointer" }} className='nav-container'>
                                    <p onClick={() => setActive("order")} style={{ color: active === "order" ? "" : "white", cursor: "pointer" }} className='nav-container-link' to='orders'>Order</p></div> </Link>
                        </section>
                        {/* <section>
                            <Link to='stock' className='nav-container-link'>
                                <div onClick={() => setActive("stock")} style={{ backgroundColor: active === "stock" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("stock")} style={{ color: active === "stock" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='stock'>stock</p></div> </Link>
                        </section> */}
                        {/* <section>
                            <Link to='products' className='nav-container-link'>
                                <div onClick={() => setActive("products")} style={{ backgroundColor: active === "products" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("stoproductsck")} style={{ color: active === "products" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='products'>all products</p></div> </Link>
                        </section> */}
                        <hr />
                        {/* <section>
                            <Link to='customer' className='nav-container-link'>
                                <div onClick={() => setActive("customer")} style={{ backgroundColor: active === "customer" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("customer")} style={{ color: active === "customer" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='customer'>Customer</p></div> </Link>
                        </section> */}
                        {/* <section>
                            <Link to='admin' className='nav-container-link'>
                                <div onClick={() => setActive("admin")} style={{ backgroundColor: active === "admin" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("admin")} style={{ color: active === "admin" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='admin'>Admin</p></div> </Link>
                        </section> */}
                        {/* <section>
                            <Link to='wallet' className='nav-container-link'>
                                <div onClick={() => setActive("wallet")} style={{ backgroundColor: active === "wallet" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("wallet")} style={{ color: active === "wallet" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='wallet'>Wallet</p></div> </Link>
                        </section> */}
                        {/* <section>
                            <Link to='invoice' className='nav-container-link'>
                                <div onClick={() => setActive("invoice")} style={{ backgroundColor: active === "invoice" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("invoice")} style={{ color: active === "invoice" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='invoice'>Invoice</p></div> </Link>
                        </section> */}


                        <hr />
                        {/* <section>
                            <Link to='report' className='nav-container-link'>
                                <div onClick={() => setActive("report")} style={{ backgroundColor: active === "report" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("report")} style={{ color: active === "report" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='report'>Report</p></div> </Link>
                        </section> */}

                        {/* <section>
                            <Link to='setting' className='nav-container-link'>
                                <div onClick={() => setActive("setting")} style={{ backgroundColor: active === "setting" ? "#004518" : "white", cursor: "pointer", borderRadius: '10px' }} className='nav-container'>
                                    <p onClick={() => setActive("setting")} style={{ color: active === "setting" ? "white" : "#004518", cursor: "pointer" }} className='nav-container-link' to='setting'>Setting</p></div> </Link>
                        </section> */}



                    </div>

                    <div style={{ textAlign: 'center' }}><button onClick={() => alert('not implemented plz wait')} style={{
                        fontWeight: '600', border: '0', height: '25px', width: '70%', backgroundColor: '#dae4dd', color: 'black', borderRadius: '5px', fontSize: '16px', cursor: 'pointer'
                    }}>Logout</button></div>
                </div>
                <div className='outputshow'>
                    <Outlet></Outlet>
                </div>
            </section>

        </div >
    );
};

export default DashboardLayout;